// .l-header__area-bar の高さ供給（SPのみ）
// バーはスクロール方向にかかわらず常にヘッダー直下へ sticky 固定で追従させるため、
// 表示/非表示の切り替えは行わない。
//
// --area-bar-height にはバーの実高さを常時反映し、後続の追従要素
// （.c-others-estate-list-header, .pg-nav）が sticky の top をこの値ぶんオフセットして
// 重なりなく並べられるようにする。
const BP_MD = 768; // @include md の閾値

const main = () => {
    const bar = document.querySelector(".l-header__area-bar");
    if (!bar) return;

    const mq = window.matchMedia(`(max-width: ${BP_MD}px)`);

    const updateAreaBarHeightVar = () => {
        document.documentElement.style.setProperty("--area-bar-height", `${bar.offsetHeight}px`);
    };

    updateAreaBarHeightVar();
    // PC⇔SPの境界(768px)をまたぐリサイズ・端末回転で表示状態が切り替わった際に、
    // 高さ0(PC)のまま固定されて後続要素が詰まりきらない/被るのを防ぐ
    mq.addEventListener("change", updateAreaBarHeightVar);
};

export default main;
